export enum StateColorEnum {
    DEFAULT = '#B8BAC2',
    OK = '#76BB79',
    CURRENT = '#003087',
    WARNING = '#F2D163',
    DANGER = '#D22630',
    NOT_VISITED = '#808080'
}
